'use strict';

const $ = require('dibs-jquery-shim');
const map = require('lodash.map');
const widgetLoader = require('../../widgets/widgetLoader');

const querystring = require('querystring');
const getSocialWindowPosition = require('../../../social/helpers/getSocialWindowPosition');
const tokenReplace = require('dibs-token-replace');

const SV = require('server-vars');
const {siteProtocol, fullDomain} = SV.get('settings');
const site = `${siteProtocol}://${fullDomain}`;

const PIN_COUNT = 'https://api.pinterest.com/v1/urls/count.json?callback=?';
const OAUTH_REDIRECT = `${site}`;
const PINTEREST_SCOPE = 'read_public,write_public';

const pinterest = {
    _load() {
        return widgetLoader.load('pinterest');
    },

    _addBoardUrlName(board) {
        const {url} = board;
        const split = url.split('/').reverse();
        board.urlName = `${split[2]}/${split[1]}`;
        return board;
    },

    _listenWindowClose(pinterestWindow) {
        return new Promise(resolve => {
            const interval = setInterval(() => {
                try {
                    if (pinterestWindow === null || pinterestWindow.closed) {
                        clearInterval(interval);
                        resolve();
                    }
                }
                catch (e) {
                    resolve();
                }
            }, 500);
        });
    },

    openWindow() {
        const width = 665;
        const height = 500;
        const windowOptions = {
            scrollbars: 'yes',
            resizable: 'no',
            toolbar: 'no',
            height: height,
            width: width,
            top: 0,
            left: 0
        };

        Object.assign(windowOptions, getSocialWindowPosition(height, width));
        return window.open('', 'pinterest', querystring.stringify(windowOptions, ','));
    },

    getPinCount(payload = {}) {
        const {url} = payload;

        return new Promise((resolve, reject) => {
            $.ajax({
                url: PIN_COUNT,
                data: {url},
                success(data) {
                    resolve(data.count);
                },
                error(err) {
                    reject(err);
                },
                dataType: 'jsonp'
            });
        });
    },

    init(payload = {}) {
        const {appId} = payload;
        const cookie = false;

        return new Promise(resolve => {
            pinterest._load().then(PDK => {
                PDK.init({appId, cookie});
                resolve();
            });
        });
    },

    isLoggedIn() {
        return new Promise((resolve, reject) => {
            pinterest._load().then(PDK => {
                const isLoggedIn = !!PDK.getSession();

                if (isLoggedIn) {
                    resolve();
                } else {
                    reject();
                }
            });
        });
    },

    login(payload = {}) {
        const {pinterestWindow, clientId} = payload;
        const loginUrl = `https://api.pinterest.com/oauth/?client_id=${clientId}&redirect_uri=${OAUTH_REDIRECT}&scope=${PINTEREST_SCOPE}&redirect_type=js&response_type=token`;
        pinterestWindow.location = loginUrl;

        return new Promise((resolve, reject) => {
            const listener = (event) => {
                const {origin, data} = event;
                if (origin === 'https://api.pinterest.com') {
                    if (data && data.access_token) {
                        resolve({
                            accessToken: data.access_token,
                            scope: PINTEREST_SCOPE
                        });
                    } else {
                        reject();
                    }

                    window.removeEventListener('message', listener);
                    pinterestWindow.close();
                }
            };

            window.addEventListener('message', listener);

            pinterest._listenWindowClose(pinterestWindow).then(() => {
                window.removeEventListener('message', listener);
                reject();
            });
        });
    },

    logout() {
        return new Promise((resolve, reject) => {
            pinterest._load().then(PDK => {
                PDK.logout((response = {}) => {
                    const {session} = response;

                    if (session) {
                        reject('Logout failed.');
                    } else {
                        resolve(session);
                    }
                });
            });
        });
    },

    setSession(session) {
        return new Promise((resolve, reject) => {
            pinterest._load().then(PDK => {
                PDK.setSession(session);

                pinterest
                    .getUser()
                    .then(user => resolve(user))
                    .catch(error => reject(error));
            });
        });
    },

    getUser() {
        return new Promise((resolve, reject) => {
            pinterest._load().then(PDK => {
                PDK.me(response => {
                    const {error, data: user} = response;

                    if (user) {
                        user.username = user.url.split('/').reverse()[1];
                        resolve(user);
                    } else if (error) {
                        reject(error);
                    }
                });
            });
        });
    },

    pin(payload = {}) {
        const PINTEREST_URL = 'https://pinterest.com/pin/create/button/?url={url}&media={media}&description={description}';
        const {pinterestWindow, url, media, description} = payload;

        pinterestWindow.location = tokenReplace(PINTEREST_URL, {url, media, description});
        return pinterest._listenWindowClose(pinterestWindow);
    },

    getBoards() {
        return new Promise((resolve, reject) => {
            pinterest._load().then(PDK => {
                PDK.me('boards', response => {
                    const {error, data: boards} = response;

                    if (boards) {
                        map(boards, board => {
                            return pinterest._addBoardUrlName(board);
                        });

                        resolve(boards);
                    } else if (error) {
                        reject(error);
                    }
                });
            });
        });
    },

    createBoard(name) {
        return new Promise((resolve, reject) => {
            pinterest._load().then(PDK => {
                PDK.request('boards', 'POST', {name}, response => {
                    const {error, data: board} = response;

                    if (board) {
                        resolve(pinterest._addBoardUrlName(board));
                    } else {
                        reject(error);
                    }
                });
            });
        });
    }
};

module.exports = pinterest;



// WEBPACK FOOTER //
// ./assets/js/global/utils/social/pinterest.es.js